import request from '@webtrader/core/request';

import { ISymbolDetail } from './detail';

interface ISymbolOrderDetailsParams {
  symbol: string;
}

const symbolOrderDetails = (params: ISymbolOrderDetailsParams) => {
  return request.get<ISymbolDetail>('/api/market/v1/symbol/order/detail', {
    params
  });
};

export default symbolOrderDetails;
